import { render, staticRenderFns } from "./BankInternalAccount.vue?vue&type=template&id=202e3a8f&scoped=true&"
import script from "./BankInternalAccount.vue?vue&type=script&lang=js&"
export * from "./BankInternalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e3a8f",
  null
  
)

export default component.exports